const BASE_DELAY_MS = 2_000;
const MAX_DELAY_MS = 5 * 60_000;

export function retryDelayMs(retryCount: number): number {
  const safeRetry = Math.max(1, Math.floor(retryCount));
  return Math.min(BASE_DELAY_MS * 2 ** (safeRetry - 1), MAX_DELAY_MS);
}

export function nextRetryAt(now: Date, retryCount: number, explicitDelayMs?: number): string {
  const delay =
    explicitDelayMs === undefined
      ? retryDelayMs(retryCount)
      : Math.max(0, Math.min(explicitDelayMs, MAX_DELAY_MS));

  return new Date(now.getTime() + delay).toISOString();
}
